import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductResource } from './product.resource.service';
import { WeborderResource } from './weborder.resource.service';
import { AuthService } from './auth.service';
import { ProductCategoryResource } from './productcategory.resource.service';
import { ProductResolver } from './product.resolver';
import { AuthResource } from './auth.resource.service';
import { OrderResource } from './order.resource.service';
import { CartResource } from './cart.resource.service';
import { ResourceModule } from '@ngx-resource/core';
import { AccountResource } from './acount.resource.service';


export interface IMongooseResult<T> {
  docs: T[];
  results: T[];
  totalDocs: number;
  limit: number;
  totalPages: number;
  page: number;
  pagingCounter: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
  prevPage: string;
  nextPage: string;
}

@NgModule({
  declarations: [],
  providers: [
    AuthResource,
    AuthService,
    OrderResource,
    ProductResource,
    ProductResolver,
    CartResource,
    WeborderResource,
    AccountResource,
    ProductCategoryResource
  ],
  imports: [
    CommonModule,
    ResourceModule
  ]
})
export class ApiModule { }
